module.exports = __webpack_public_path__ + "static/colgadas-015-e96a4474b62276422c98cd88dc67e299.jpg";